import { VStack } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useWatch } from "react-hook-form";
import {
  ReviewFullFragment,
  useGetCampaignLazyQuery,
} from "../../../graphql/generated/definitions";
import useTranslations from "../../../hooks/useTranslations";
import { FormStepProps } from "../../../screens/ReviewFormScreen";
import { Input, Radio, RadioGroup } from "../../wombat-ui";

const ReviewReminderForm: React.FC<
  Omit<FormStepProps, "onNext" | "formState"> & {
    defaultValues?: ReviewFullFragment;
  }
> = ({ register, control, setValue, getValues, defaultValues }) => {
  const t = useTranslations();

  useEffect(() => {
    register("reminderGap");
    register("reminderEnabled");
  }, [defaultValues]);

  const reminderSelector = useWatch({
    control: control,
    name: `reminderEnabled`,
  });

  const [getCampaign, { data }] = useGetCampaignLazyQuery();

  useEffect(() => {
    if (!defaultValues?.id) {
      if (getValues("campaignId") && !data)
        getCampaign({ variables: { id: getValues("campaignId") } });
      setValue(
        "reminderEnabled",
        data?.campaign?.reminderEnabled ? "true" : "false"
      );
      setValue("reminderGap", data?.campaign?.reminderGap || 7);
    }
  }, [data, getValues("campaignId"), defaultValues]);

  return (
    <VStack align="start">
      <RadioGroup
        title={t("reviews.reminderEnabledLabel")}
        description={t("reviews.reminderEnabledDescription")}
      >
        <Radio
          id="reminder-true"
          name="reminderEnabled"
          label={t("forms.actions.yes") as string}
          value="true"
          ref={register()}
        />
        <Radio
          id="reminder-false"
          name="reminderEnabled"
          label={t("forms.actions.no") as string}
          value="false"
          ref={register()}
        />
      </RadioGroup>
      {reminderSelector === "true" && (
        <Input
          label={t("company.reminderGapLabel") as string}
          type="number"
          min={1}
          size="small"
          id="reminderGap"
          name="reminderGap"
          ref={register({ valueAsNumber: true })}
          defaultValue={defaultValues?.reminderGap}
        />
      )}
    </VStack>
  );
};

export default ReviewReminderForm;
